import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  HttpOptions
} from '../../../shared/models/http.model';
import { HttpService } from '../../../shared/services/http.service';
import { ClientService } from '../../clients/services/client.service';
import { ClientsResponse } from '../models/clients-response.model';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private httpOptions: HttpOptions;

  constructor(
    private httpService: HttpService,
    private httpClient: HttpClient,
    private clientService: ClientService
  ) {
    this.httpOptions = this.httpService.getHttpOptions();
  }

  public getTenantClients(
    tenantId: string, 
    page: number = 1, 
    limit: number = 10, 
    search?: string
  ): Observable<ClientsResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    
    if (search) {
      params = params.set('search', search);
    }

    const options = {
      ...this.httpOptions,
      params
    };

    return this.httpClient
      .get<ClientsResponse>(
        `${environment.nestApiUrl}/tenant/${tenantId}/clients`,
        options
      )
      .pipe(
        tap((response: ClientsResponse) => {
          this.clientService.setClients(response.data);
        }),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  getCurrentTenantId(): string {
    return localStorage.getItem('tenantId') || 'atomix'; 
  }
}
